import {useSupportedCurrencies, useSupportedCurrency} from "./useSupportedCurrencies.js";

export function useRenderPercentValue() {
    return (amount, roundToWhole = false) => {
        if (amount === null) {
            return '-';
        }

        if (roundToWhole) {
            amount = Math.round(amount);
        } else {
            amount = Math.round(amount * 100) / 100;
        }

        amount = amount.toString().replaceAll('.', ',');

        return amount + " %";
    };
}

export function useRenderNumber()
{
    return (number) => {
        if(number === null || number === undefined) {
            return '-';
        }

        return number.toLocaleString('cs-CZ', { maximumFractionDigits: 0 });
    };
}

export function useRenderTime() {
    return (date, noMidnight = false) => {
        if (date === null) {
            return '-';
        }

        let renderedTime = date.toLocaleTimeString('cs-CZ');

        if (noMidnight && (renderedTime === '0:00:00' || renderedTime === '00:00:00')) {
            return '';
        }

        return renderedTime;
    };
}

export function useRenderDate() {
    return (date) => {
        if (date === null) {
            return '-';
        }

        return date.toLocaleDateString(
            'cs-CZ',
            {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            }
        );
    };
}

export function useRenderCurrencyValue() {
    let getSupportedCurrency = useSupportedCurrency();

    return (moneyValue, hideCents = false) => {
        if(moneyValue === null || moneyValue === undefined) {
            return '-';
        }

        let value = moneyValue['amount'] / 100;

        if (hideCents) {
            value = parseInt(Math.round(value));
        }

        let supportedCurrency = getSupportedCurrency(moneyValue['currency']);

        if(supportedCurrency !== null) {
            return new Intl.NumberFormat(supportedCurrency['locale'], {
                style: 'currency',
                currency: supportedCurrency['value'],
                maximumFractionDigits: (hideCents ? 0 : 2),
            }).format(value);
        }

        return (value) + ' ' + moneyValue['currency'];
    };
}

export function useRenderCurrencySign() {
    let supportedCurrencies = useSupportedCurrencies();

    return (currencyCode) => {

        for(let supportedCurrency of supportedCurrencies) {
            if(supportedCurrency.code === currencyCode) {
                return supportedCurrency.label;
            }
        }

        return '-';
    };
}
